import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { PlayerEnum } from '../../Player/constants';
import { getPlayerColor } from '../../../utils/playerColor';
import PlayerNamesContext from './PlayerNamesContext';
import { IPlayerName } from '../../../../../shared/types/player.type';
import { changePlayerNames } from '../../Game/Game';

const StyledPlayerNames = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 200px;
`;

const StyledPlayerNameInput = styled.input<{
  number: PlayerEnum;
  value: string;
}>`
  border-radius: 4px;
  background-color: ${(props) =>
    props.value !== '' ? 'auto' : getPlayerColor(props.number)};
  color: ${(props) => getPlayerColor(props.number)};
  text-shadow:
    -1px 0 black,
    0 1px black,
    1px 0 black,
    0 -1px black;
  font-weight: bold;
  font-size: 20px;
  margin: 5px;
`;
const getPlayerName = (number: PlayerEnum, names: IPlayerName[]): string => {
  const player = names.find((n) => n.player === number);
  return player?.name ? player.name : '';
};

let timeOut: NodeJS.Timeout;
const PlayerNames = () => {
  const { names } = useContext(PlayerNamesContext);
  const [namesState, setNamesState] = useState<IPlayerName[]>([]);
  useEffect(() => {
    setNamesState(names);
  }, [names, setNamesState]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    player: PlayerEnum,
  ) => {
    if (timeOut) clearTimeout(timeOut);
    const newNames: IPlayerName[] = namesState.map((n): IPlayerName => {
      if (n.player === player) {
        return { player: n.player, name: e.target.value };
      }
      return n;
    });
    setNamesState(newNames);

    timeOut = setTimeout(() => {
      changePlayerNames(newNames);
    }, 1000);
  };

  return (
    <StyledPlayerNames>
      {namesState.map((n) => (
        <StyledPlayerNameInput
          key={n.player}
          number={n.player}
          onChange={(e) => handleChange(e, n.player)}
          value={getPlayerName(n.player, namesState)}
        />
      ))}
    </StyledPlayerNames>
  );
};

export default PlayerNames;
